/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Catalog_TitleInputs */



/**
* | output |
* | --- |
* | "Promo catalog" |
*
* @param {Promo_Catalog_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_catalog_title = /** @type {((inputs?: Promo_Catalog_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Catalog_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Catalogue des promos")
	if (locale === "es") return /** @type {LocalizedString} */ ("Catálogo de promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Catálogo de promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Catalogo delle promo")
	return /** @type {LocalizedString} */ ("Promo catalog")
});